
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import en from './en';

export default {
  translation: {
    ...en.translation,
    header_title: "Constantina",
    nav_shopping_assistant: "Assistant Shopping",
    nav_assistant_short: "Assistant",
    "nav_style_lab": "Style Lab",
    nav_studio: "Studio de Style",
    nav_tryon: "Essai Virtuel",
    nav_actions_title: "Actions",
    portfolio_instagram_connect_title: 'Connectez-vous sur Instagram',
    "shoppingAssistant_title": "Assistant Shopping",
    "shoppingAssistant_subtitle": "Propulsé par l'IA",
    "shoppingAssistant_greeting": "Salut ! Je suis votre assistant shopping IA. Comment puis-je vous aider aujourd'hui ? Vous pouvez me demander de trouver des produits, de vérifier l'état de votre commande ou de vous aider avec les retours.",
    "shoppingAssistant_error_connection": "Désolé, j'ai du mal à me connecter en ce moment.",
    "shoppingAssistant_history_cleared": "Historique effacé. Comment puis-je vous aider aujourd'hui ?",
    "shoppingAssistant_clear_history": "Effacer la conversation",
    "shoppingAssistant_close": "Fermer l'assistant",
    "shoppingAssistant_role_assistant": "Assistant",
    "shoppingAssistant_copy_caption": "Copier la légende",
    "shoppingAssistant_social_media_title": "Légendes sociales générées par l'IA",
    "shoppingAssistant_save_to_advice": "Enregistrer dans Conseils",
    "shoppingAssistant_select_slot": "Sélectionner",
    "shoppingAssistant_thinking": "L'assistant réfléchit...",
    "shoppingAssistant_input_placeholder": "Rechercher des produits, suivre des commandes...",
    "shoppingAssistant_send_aria": "Envoyer le message",
    "shoppingAssistant_suggest_summer_dresses": "Robes d'été",
    "shoppingAssistant_suggest_track_order": "Suivre la commande",
    "shoppingAssistant_suggest_return_policy": "Politique de retour",
    "shoppingAssistant_response_products": "J'ai trouvé quelques {{category}} qui pourraient vous plaire :",
    "shoppingAssistant_response_order_status": "Voici l'état de votre commande {{orderId}} :",
    "shoppingAssistant_response_order_not_found": "Je n'ai pas pu trouver cette commande. Veuillez vérifier l'ID de commande et réessayer.",
    "shoppingAssistant_response_return_policy": "Notre politique de retour vous permet de retourner les articles dans les 30 jours suivant la livraison. Les articles doivent être non portés et dans leur emballage d'origine. Souhaitez-vous commencer un retour pour une commande spécifique ?",
    "shoppingAssistant_response_social_media": "J'ai préparé quelques légendes de réseaux sociaux personnalisées basées sur votre look actuel ! Laquelle préférez-vous ?",
    "shoppingAssistant_response_social_no_garment": "J'adorerais vous aider avec un post ! Pourriez-vous d'abord sélectionner un vêtement dans la cabine d'essayage pour que j'aie de quoi écrire ?",
    "shoppingAssistant_response_booking": "Je peux certainement vous aider à réserver une séance de stylisme professionnelle. Quand y pensiez-vous ?",
    "shoppingAssistant_service_styling_consultation": "Consultation de stylisme personnelle",
    "shoppingAssistant_response_wardrobe_matches": "J'ai trouvé quelques correspondances dans votre garde-robe, plus quelques pièces de notre catalogue pour compléter le look :",
    "shoppingAssistant_response_retail_matches": "Basé sur vos préférences de style, j'ai trouvé ces articles pour vous :",
    "shoppingAssistant_response_greeting": "Bonjour ! Je suis votre style personnel et assistant shopping. Je peux vous aider à trouver des produits (dans notre boutique ou votre garde-robe), créer des posts sur les réseaux sociaux pour vos looks, ou réserver une consultation. Comment puis-je vous aider aujourd'hui ?",
    "shoppingAssistant_response_fallback": "Je suis là pour vous aider avec votre style ! Vous pouvez me demander de trouver des produits, de créer des posts sociaux, ou de vous donner des conseils de mode.",
    "shoppingAssistant_order_status_label": "État de la commande",
    "shoppingAssistant_order_id_label": "ID de la commande",
    "shoppingAssistant_order_date_label": "Date",
    "shoppingAssistant_order_items_label": "Articles",
    "shoppingAssistant_order_total_label": "Montant total",
    "shoppingAssistant_order_est_delivery_label": "Livraison prévue",
    "shoppingAssistant_order_track_cta": "Suivre le colis",
    "shoppingAssistant_order_status_shipped": "Expédié",
    "shoppingAssistant_order_status_delivered": "Livré",
    "shoppingAssistant_order_status_processing": "En cours",
    "shoppingAssistant_product_in_wardrobe": "Dans votre garde-robe",
    "shoppingAssistant_product_low_stock": "Stock faible",
    "shoppingAssistant_product_price_wardrobe": "GARDE-ROBE",
    "shoppingAssistant_product_add_to_basket": "Ajouter au panier",
    "shoppingAssistant_product_owned": "Possédé",
    "shoppingAssistant_product_already_in_wardrobe": "Déjà dans votre garde-robe",
    "portfolio_instagram_connect_desc": 'Suivez nos histoires de style quotidiennes, le contenu en coulisses et les fonctionnalités communautaires.',
    "common_connect": 'Connecter',
    "voucher_title": "Chèques Cadeaux",
    "voucher_cta": "Acheter un Chèque",
    "voucher_tagline": "Offrez du style.",
    "portfolio_feature_color_analysis": "Analyse de Couleur",
    "portfolio_feature_all_complete_features": "Toutes les prestations du forfait complet",
    "trends_page_subtitle": "Tendances Actuelles",
    "trends_page_title": "Tendances Mode",
    "trends_page_description": "Découvrez les dernières tendances mode sélectionnées pour votre génération.",
    "trends_filter_all": "Toutes les Générations",
    "portfolio_video_views": 'Vues',
    "colorStudio_title": "Studio d'analyse des couleurs",
    "feature_locked_guest": "Fonctionnalité verrouillée (Invité)",
    "shoppingAssistant_membership_locked": "L'assistant d'achat est disponible pour nos membres Premium et Advanced.",
    "upgrade_membership": "Mettre à niveau l'adhésion",
    "view_plans": "Voir les plans",
    "colorStudio_premium_required": "Déverrouillez l'analyse personnalisée des couleurs saisonnières et les recommandations de palette. Disponible pour les membres Premium et Advanced.",
    "colorStudio_subtitle": "Libérez le pouvoir de la couleur. Découvrez les nuances qui s'harmonisent avec votre teint, vos cheveux et vos yeux uniques.",
    "colorStudio_powerColors_desc": "Les couleurs clés qui subliment votre beauté.",
    "colorAnalysis_title": "Analyse de couleur",
    "colorAnalysis_confirm_new": "Vous avez déjà une analyse de couleur dans votre profil. Souhaitez-vous en effectuer une nouvelle basée sur la détection d'image ?",
    "colorAnalysis_analyze_new": "Analyser une nouvelle photo",
    "colorAnalysis_analyzing": "Analyse de vos couleurs en cours...",
    "colorAnalysis_analyzing_subtext": "Détermination de la saison, du teint et du contraste.",
    "colorAnalysis_upload_title": "Télécharger une photo",
    "colorAnalysis_upload_btn": "Sélectionner une image",
    "colorAnalysis_season_label": "Votre saison",
    "colorAnalysis_characteristic_skin": "Peau :",
    "colorAnalysis_characteristic_contrast": "Contraste :",
    "colorAnalysis_characteristic_eyes": "Yeux :",
    "colorAnalysis_characteristic_hair": "Cheveux :",
    "colorAnalysis_powerColors": "Couleurs fortes",
    "colorAnalysis_neutrals": "Tons neutres",
    "colorAnalysis_avoid": "Couleurs à éviter",
    "colorAnalysis_advice_hair_makeup": "Cheveux & maquillage",
    "colorAnalysis_advice_clothing": "Conseils vestimentaires",
    "colorAnalysis_error": "L'analyse a échoué.",
    "colorAnalysis_no_result_title": "Pas encore d'analyse de couleur",
    "colorAnalysis_no_result_desc": "Téléchargez une photo ou sélectionnez une tenue enregistrée pour découvrir votre saison de couleurs personnelle et votre palette.",
    "colorAnalysis_start_button": "Lancer mon analyse de couleur",
    "colorAnalysis_label_hair": "Cheveux",
    "colorAnalysis_label_makeup": "Maquillage",
    "colorAnalysis_label_jewelry": "Bijoux",
    "colorAnalysis_saved_to_profile": "Enregistré dans le profil",
    "colorAnalysis_save_to_profile": "Enregistrer l'analyse dans le profil",
    "colorAnalysis_apply_palette_title": "Appliquer la palette à la tenue",
    "colorAnalysis_apply_palette_hint": "Cliquez sur une couleur ci-dessous pour l'appliquer",
    "colorAnalysis_apply_color_aria": "Appliquer la couleur {{color}}",
    "colorAnalysis_target_item": "Article cible",
    "colorAnalysis_powerColors_desc": "Ces couleurs essentielles projettent votre confiance et votre éclat maximum.",
    "colorAnalysis_admin_mode": "ADMIN",
    "colorAnalysis_admin_analyzing": "Analyse de la sélection en cours...",
    "colorAnalysis_admin_label": "Mode Admin :",
    "colorAnalysis_admin_desc": "Téléchargez une photo de tenue détaillée pour extraire les articles et créer un ensemble Shop the Look.",
    "colorAnalysis_admin_save_set": "Enregistrer dans les ensembles sélectionnés",
    "colorAnalysis_admin_shop_now": "Lien Shop Now",
    "colorAnalysis_admin_failed_analyze": "Échec de l'analyse de l'ensemble",
    "colorAnalysis_admin_failed_save": "Échec de l'enregistrement.",
    "colorAnalysis_admin_curated_saved": "Ensemble et articles enregistrés localement ! (Rafraîchir pour voir dans la garde-robe)",
    "colorAnalysis_characteristic_skinTone": "Teint :",
    "colorAnalysis_characteristic_hairColor": "Couleur des cheveux :",
    "colorAnalysis_characteristic_eyeColor": "Couleur des yeux :",
    "colorAnalysis_characteristic_faceShape": "Forme du visage :",
    "colorAnalysis_characteristic_bodySize": "Morphologie :",
    "colorAnalysis_save_to_advice_title": "Analyse des couleurs - {{season}}",
    "colorAnalysis_unknown": "Inconnu",
    "colorAnalysis_saved_to_profile_success": "Enregistré dans le profil",
    "myStylesPage_savedColorAnalysis_title": "Mes analyses de palette de couleurs",
    "myStylesPage_savedColorAnalysis_desc": "Votre historique de découvertes de couleurs personnelles et de saisonnalité.",
    "myStylesPage_noSavedAnalysis": "Aucun résultat d'analyse de couleur enregistré.",

    rss_source_constantina: "Constantina",
    stylingAdvisorPage_startChat: 'Démarrer le Chat',
    myStylesPage_sourceOutfit: 'Source de la Tenue',
    myStylesPage_social_linkedin: 'LinkedIn',
    myStylesPage_social_twitter: 'Twitter',
    myStylesPage_social_instagram: 'Instagram',
    blog_post_not_found: 'Article non trouvé.',
    common_pdf: 'PDF',
    resource_category_style: 'Style',
    resource_category_color: 'Couleur',
    resource_category_business: 'Affaires',

    "rss_1_title": "Le guide Vogue des tendances 2024",
    "rss_1_snippet": "Découvrez les pièces clés définissant l'esthétique de cette saison.",
    "rss_2_title": "Temps Forts Street Style",
    "rss_2_snippet": "Les meilleurs looks capturés dans les rues de Milan et Paris.",
    "rss_3_title": "L'Avenir de la Chaussure",
    "rss_3_snippet": "Les dernières sorties et collaborations qui définissent la scène sneaker.",
    "rss_4_title": "Luxe Durable",
    "rss_4_snippet": "Comment les marques haut de gamme adoptent des matériaux écologiques.",
    "rss_5_title": "Beauté Décodée",
    "rss_5_snippet": "Les tendances beauté phares directement des podiums.",

    "campaign_new_year_title": "Nouvelle Année, Nouveau Style",
    "campaign_new_year_desc": "Rafraîchissez votre look pour la nouvelle année.",
    "campaign_event_glamour_title": "Glamour Événementiel",
    "campaign_event_glamour_desc": "Brillez lors de votre prochain grand événement.",
    "campaign_executive_title": "Présence Exécutive",
    "campaign_executive_desc": "Dominez la pièce avec une image professionnelle puissante.",
    "campaign_color_title": "Palette Parfaite",
    "campaign_color_desc": "Découvrez les couleurs qui vous font briller.",
    "campaign_shopping_title": "Shopping Intelligent",
    "campaign_shopping_desc": "Des pièces curatées qui correspondent parfaitement à votre style de vie.",
    "campaign_style_transformation_title": "Transformation Totale",
    "campaign_style_transformation_desc": "Réinventez-vous avec notre atelier de stylisme complet.",
    "campaign_summer_title": "Style Estival Radiant",
    "campaign_summer_desc": "Accueillez le soleil avec des palettes vibrantes et des silhouettes respirantes.",
    "campaign_easter_title": "Renouveau de Pâques",
    "campaign_easter_desc": "Rafraîchissez votre look avec une élégance pastel et des textures saisonnières.",

    "campaign_soft_power_title": "Révolution Soft Power",
    "campaign_soft_power_desc": "Adoptez l'esthétique exécutive de 2026 : épaules arrondies, tailleurs pastel et coupes fluides.",
    "campaign_sportif_chic_title": "Sportif Chic & Bien-être",
    "campaign_sportif_chic_desc": "Le sportswear élevé rencontre le luxe quotidien. Tissus techniques avec des touches féminines.",
    "campaign_badge_trending": "Tendance",

    "campaign_badge_limited_time": "Temps Limité",
    "campaign_badge_events": "Spécial Saison",
    "campaign_badge_professional": "Professionnel",
    "campaign_badge_bestseller": "Best-seller",
    "campaign_badge_seasonal": "Saisonnier",
    "campaign_badge_exclusive": "Exclusif",
    "campaign_included_services": "Services Inclus",

    "wardrobe_searchPlaceholder": "Rechercher des articles...",
    "price_basic_weekly": "9,99 €/semaine",
    "price_basic_monthly": "29,99 €/mois",
    "price_basic_quarterly": "79,99 €/trimestre",
    "price_premium_weekly": "19,99 €/semaine",
    "price_premium_monthly": "59,99 €/mois",
    "price_premium_quarterly": "159,99 €/trimestre",
    "price_advanced_weekly": "39,99 €/semaine",
    "price_advanced_monthly": "119,99 €/mois",
    "price_advanced_quarterly": "319,99 €/trimestre",
    "price_nextgen_weekly": "4,99 €/semaine",
    "price_nextgen_monthly": "14,99 €/mois",
    "price_business_workshop_corporate": "5.000 €+",
    "price_style_transformation_essential": "450 €",
    "price_style_transformation_complete": "850 €",
    "price_style_transformation_vip": "1.500 €",
    "loading_updating_item": "Mise à jour de l'article...",
    "loading_updating_pose": "Changement de pose en {{poseName}}...",
    "loading_updating_background": "Mise à jour de l'arrière-plan...",
    "loading_updating_3d": "Génération de la vue 3D ({{current}}/4)...",
    "error_update_outfit": "Échec de la mise à jour de la tenue. {{details}}",
    "error_save_outfit": "Échec de l'enregistrement de la tenue. {{details}}",
    "common_user": "Utilisateur",
    "common_back": "Retour",
    "common_next": "Suivant",
    "canvas_colorPicker_title": "Sélecteur de couleur",
    "wardrobe_item_tooltip_locked": "Verrouillé : nécessite un abonnement {{level}}.",
    "wardrobe_item_tooltip_category": "Catégorie : {{category}}",
    "wardrobe_item_tooltip_color": "Couleur par défaut : {{color}}",
    "wardrobe_brand_ai_generated": "Généré par IA",
    "wardrobe_item_ai_name_prefix": "IA : {{prompt}}",

    // Capsule Generator
    "capsuleGenerator_title": "Générateur de Garde-robe Capsule IA",
    "capsuleGenerator_subtitle": "Créez une garde-robe polyvalente et cohérente, adaptée à votre style et à l'occasion.",
    "capsuleGenerator_premium_required": "Cet outil de stylisme IA avancé est disponible pour nos membres Premium et Advanced.",
    "capsuleGenerator_select_season": "Sélectionner la Saison",
    "capsuleGenerator_select_occasion": "Sélectionner l'Occasion",
    "capsuleGenerator_generate_btn": "Générer la Capsule",
    "capsuleGenerator_generating": "Conception de votre capsule...",
    "capsuleGenerator_season_spring": "Printemps",
    "capsuleGenerator_season_summer": "Été",
    "capsuleGenerator_season_autumn": "Automne",
    "capsuleGenerator_season_winter": "Hiver",
    "capsuleGenerator_occasion_work": "Tenues Professionnelles",
    "capsuleGenerator_occasion_casual": "Décontracté Week-end",
    "capsuleGenerator_occasion_travel": "Voyages & Vacances",
    "capsuleGenerator_occasion_formal": "Événements Formels",
    "capsuleGenerator_result_palette": "Palette de Couleurs",
    "capsuleGenerator_result_items": "Pièces Clés",
    "capsuleGenerator_result_combinations": "Combinaisons de Tenues",
    "capsuleGenerator_seo_title": "Générateur de Garde-robe Capsule IA | Constantina Lifestyle",
    "capsuleGenerator_seo_desc": "Générez une garde-robe capsule personnalisée basée sur votre saison de couleurs, votre morphologie et votre style à l'aide d'une IA avancée.",
    "capsuleGenerator_seo_keywords": "garde-robe capsule, styliste IA, planification de mode, garde-robe minimaliste, analyse de saison de couleur",

    // Retail Search
    "retailSearchModal_title": "Trouver des Articles Similaires",
    "retailSearchModal_titleForGarment": "Similaire à : {{garmentName}}",
    "retailSearchModal_close": "Fermer",
    "retailSearchModal_refine_title": "Affiner la Recherche",
    "retailSearchModal_refine_color": "Couleur",
    "retailSearchModal_refine_pattern": "Motif",
    "retailSearchModal_refine_material": "Matière",
    "retailSearchModal_refine_color_placeholder": "ex. Bleu Marine",
    "retailSearchModal_refine_pattern_placeholder": "ex. Rayé",
    "retailSearchModal_refine_material_placeholder": "ex. Soie",
    "retailSearchModal_refine_button": "Mettre à jour la Recherche",
    "retailSearchModal_loading": "Recherche parmi les détaillants mondiaux...",
    "retailSearchModal_noResults": "Aucun article similaire trouvé.",
    "retailSearchModal_sources": "Sources",
    "retailSearchModal_noPreview": "Pas d'aperçu",
    // ... existing translations
    "appName": "Constantina",
    "nav_home": "Accueil",
    "nav_about": "À propos",
    "nav_portfolio": "Portfolio",
    "nav_blog": "Blog",
    "nav_trends": "Tendances",
    "nav_bookSession": "Réserver",
    "trend_tag_heritage": "Héritage",
    "trend_tag_sculpted": "Sculpté",
    "trend_tag_heritage_fusion": "Fusion Héritage",
    "trend_tag_ai_vision": "Vision IA",
    "trend_tag_emerging": "Émergent",
    "trend_tag_alpine_chic": "Chic Alpin",
    "trend_tag_cyber_soft": "Cyber Soft",
    "trend_tag_poet_core": "Poet Core",
    "trend_tag_glamoratti": "Glamoratti",
    "trend_tag_guardian": "Guardian",
    "trend_alpha_cyber_soft_title": "Fusion Pastel Numérique",
    "trend_z_poet_core_title": "Académique Romantique",
    "trend_millennial_glamoratti_title": "Opulence Années 80",
    "trend_classic_guardian_title": "Élégance Protectrice",
    "nav_dressingRoom": "Cabine d'essayage",
    "nav_myStyles": "Mes styles",
    "nav_advisor": "Conseiller de style",
    "nav_privacy": "Confidentialité",
    "nav_terms": "Conditions",
    "nav_impressum": "Mentions légales",
    "nav_startOver": "Recommencer",
    "nav_save": "Sauvegarder",
    "nav_share": "Partager",
    "nav_findSimilar": "Trouver similaire",
    "nav_getStyleTip": "Obtenir des conseils",
    "nav_lookbook": "Lookbook",
    "nav_lightMode": "Mode clair",
    "nav_darkMode": "Mode sombre",
    "nav_switchUser": "Changer d'utilisateur",
    "nav_profile": "Profil",
    "nav_wardrobe": "Garde-robe",
    "nav_outfit": "Tenue",
    "nav_guestCta": "Connectez-vous pour accéder",
    "nav_show_wardrobe": "Afficher la garde-robe",
    "nav_hide_wardrobe": "Masquer la garde-robe",
    "nav_show_outfit": "Afficher la tenue",
    "nav_hide_outfit": "Masquer la tenue",
    "nav_signInGoogle": "Se connecter avec Google",
    "nav_signInFacebook": "Se connecter avec Facebook",
    "nav_rememberMe": "Se souvenir de moi",
    "nav_signUp": "S'inscrire",
    "nav_emailPlaceholder": "E-mail",
    "nav_passwordPlaceholder": "Mot de passe",
    "nav_signUpButton": "Créer un compte",
    "nav_continueWith": "Ou continuer avec",
    "nav_guestUser": "(Invité)",
    "nav_proceedToStyling": "Passer au stylisme",
    "nav_help": "Centre d'aide",

    "footer_company": "Entreprise",
    "footer_legal": "Légal",
    "footer_subscribe_title": "Restez à la mode",
    "footer_subscribe_desc": "Abonnez-vous à notre newsletter pour des conseils de style exclusifs.",
    "footer_subscribe_placeholder": "Entrez votre e-mail",
    "footer_subscribe_button_aria": "S'abonner",
    "footer_subscribe_success": "Merci de vous être abonné !",
    "footer_subscribe_error": "Veuillez entrer une adresse e-mail valide.",
    "footer_copyright": "Tous droits réservés.",
    "footer_createdBy": "Créé par",

    "portfolio.title": "Portfolio",
    "portfolio.description": "Une sélection de nos meilleurs travaux.",
    "portfolio.searchPlaceholder": "Rechercher dans le portfolio...",
    "portfolio.noResults.title": "Aucun projet trouvé",
    "portfolio.noResults.message": "Essayez d'autres termes de recherche.",
    "portfolio_category_editorial": "Éditorial",
    "portfolio_category_street": "Style urbain",
    "portfolio_category_commercial": "Commercial",
    "portfolio_category_portraits": "Portraits",
    "portfolio_category_personal": "Stylisme personnel",
    "portfolio_category_wardrobe": "Garde-robe",
    "portfolio_category_events": "Événements",
    "portfolio_category_specialty": "Spécialité",
    "portfolio.item1.title": "Vogue Urbain",
    "portfolio.item1.desc": "Éditorial City Chic",
    "portfolio.item2.title": "Rythme de la rue",
    "portfolio.item2.desc": "Mode de rue contemporaine",
    "portfolio.item3.title": "Brume d'été",
    "portfolio.item3.desc": "Campagne commerciale",
    "portfolio.item4.title": "Muse moderne",
    "portfolio.item4.desc": "Éditorial haute couture",
    "portfolio.item5.title": "Essence brute",
    "portfolio.item5.desc": "Portraits en lumière naturelle",

    "socialCarousel_simulation_note": "* Fil de réseaux sociaux simulé",

    "portfolioPage_service_personalStyling_title": "Stylisme Personnel",
    "portfolioPage_service_personalStyling_description": "Relooking complet.",
    "portfolioPage_service_wardrobeCuration_title": "Curation de Garde-robe",
    "portfolioPage_service_wardrobeCuration_description": "Optimisez votre placard.",
    "portfolioPage_service_eventStyling_title": "Stylisme d'Événement",
    "portfolioPage_service_eventStyling_description": "Le look parfait pour toute occasion.",
    "portfolioPage_service_individualShopping_title": "Shopping Personnel",
    "portfolioPage_service_individualShopping_description": "Expérience de shopping curée.",
    "portfolioPage_service_makeupAdvisory_title": "Conseil Maquillage",
    "portfolioPage_service_makeupAdvisory_description": "Beauté adaptée à votre style.",
    "portfolioPage_service_colorAnalysis_title": "Analyse de Couleur",
    "portfolioPage_service_colorAnalysis_description": "Trouvez votre palette parfaite.",
    "portfolioPage_service_premiumInPerson_title": "Premium en Personne",
    "portfolioPage_service_businessWorkshops_title": "Ateliers d'affaires",
    "portfolioPage_service_businessWorkshops_description": "Améliorez l'image professionnelle de votre équipe.",
    "portfolioPage_service_styleTransformation_title": "Transformation de Style",
    "portfolioPage_service_styleTransformation_description": "Une réinvention complète de votre style personnel.",
    "portfolioPage_package_essential": "Essentiel",
    "portfolioPage_package_complete": "Complet",
    "portfolioPage_package_vip": "VIP",

    "styleReport_title": "Rapport de style",
    "styleReport_generatedFor": "Généré pour {{username}}",
    "styleReport_date": "Date",
    "styleReport_profile_title": "Profil de style",
    "styleReport_no_persona": "Aucun profil de style généré pour le moment.",
    "styleReport_outfits_title": "Tenues enregistrées",
    "styleReport_lookbooks_title": "Lookbooks",
    "styleReport_plans_title": "Plans de style",
    "styleReport_no_plans": "Aucun plan de style enregistré.",
    "styleReport_back": "Retour à mes styles",
    "styleReport_print": "Imprimer le rapport",

    "agentWorkflow_title": "Agent de Stylisme",
    "agentWorkflow_greeting": "Bonjour ! Je suis votre Agent de Stylisme dédié. Je peux vous aider à trouver des articles, réserver des rendez-vous ou créer du contenu pour les réseaux sociaux. Que souhaitez-vous faire ?",
    "agentWorkflow_error_noItemsFound": "Je n'ai trouvé aucun article similaire pour le moment.",
    "agentWorkflow_fallback": "Je n'ai pas bien compris. Essayez de demander 'trouver des articles similaires' ou 'réserver une séance'.",
    "agentWorkflow_error": "Désolé, une erreur s'est produite.",
    "agentWorkflow_thinking": "Traitement en cours...",
    "agentWorkflow_placeholder": "Tapez une demande...",
    "agentWorkflow_socialMediaSavedTitle": "Contenu Réseaux Sociaux",

    "trendSpotter.greeting": "Prêt à avoir une longueur d'avance ? Je suis votre Chasseur de Tendances. Interrogez-moi sur les derniers succès des défilés, les styles urbains viraux ou les couleurs qui dominent cette saison !",
    "trendSpotter.cleared": "Historique du chat effacé.",
    "trendSpotter.thinking": "Analyse des tendances mondiales...",
    "trendSpotter.placeholder": "Interroger sur les tendances émergentes...",

    "homePage_businessStyling": "Pour les entreprises",
    "homePage_cta": "Essayer virtuellement",
    "loading_rendering": "Rendu des détails...",
    "loading_generating_model": "Création du nouveau vous...",
    "homePage_bookConsultation": "Réserver une consultation",
    "homePage_uploadInput_label": "Téléchargez votre photo",
    "homePage_visionTitle": "Notre Vision",
    "homePage_vision_time_title": "Gain de temps",
    "homePage_vision_time_desc": "Visualisation instantanée.",
    "homePage_vision_quality_title": "Qualité d'abord",
    "homePage_vision_quality_desc": "Résultats haute fidélité.",
    "homePage_vision_digitalTwin_title": "Jumeau Numérique",
    "homePage_vision_digitalTwin_desc": "Votre vous virtuel.",
    "homePage_transformation_title": "Transformation",
    "homePage_transformation_desc": "Voyez la différence.",
    "aboutPage_socialText": "Restez au courant de nos dernières tendances.",
    "about_usp_title": "Pourquoi Constantina ?",
    "about_usp_1_title": "IA centrée sur l'humain",
    "about_usp_1_desc": "L'efficacité de AI combinée à l'intuition de stylistes experts.",
    "about_usp_2_title": "Tendances basées sur les données",
    "about_usp_2_desc": "Analyse en temps réel des tendances mondiales depuis les principales capitales de la mode.",
    "about_usp_3_title": "Branding Personnel",
    "about_usp_3_desc": "Nous ne nous contentons pas de vous habiller ; nous vous aidons à projeter votre moi le plus authentique.",
    "about_usp_4_title": "Portée mondiale",
    "about_usp_4_desc": "Un stylisme haut de gamme accessible, où que vous soyez dans le monde.",
    "about_certification_title": "Nos Certifications",
    "about_certification_desc": "Une expertise reconnue par les institutions leaders de la mode.",
    "aboutPage_certified_milano": "Master en Fashion Styling - Milan",
    "aboutPage_certified_london": "Communication de Mode - Londres",
    "booklet_minimalist_title": "Le Guide de la Garde-Robe Minimaliste",
    "booklet_minimalist_desc": "Maîtrisez l'art de construire une garde-robe polyvalente et de haute qualité avec moins de pièces.",
    "booklet_color_theory_title": "Essentiels de la Théorie des Couleurs",
    "booklet_color_theory_desc": "Découvrez votre palette de couleurs parfaite et apprenez à créer des tenues harmonieuses.",
    "booklet_executive_title": "Stylisme de Présence Executive",
    "booklet_executive_desc": "Guide de stylisme professionnel pour renforcer votre autorité à travers votre garde-robe.",
    "booklet_capsule_title": "Le Plan de la Garde-Robe Capsule",
    "booklet_capsule_desc": "Guide complet pour créer des collections capsules saisonnières qui s'harmonisent.",
    "booklet_downloading": "Téléchargement en cours",
    "aboutPage_title": "L'Art du Stylisme rencontre l'Intelligence Artificielle",
    "aboutPage_tagline": "Faire le pont entre l'élégance intemporelle et la technologie de pointe de la mode.",
    "aboutPage_paragraph1": "Fondée au cœur de la Suisse, Constantina est née d'une vision unique : démocratiser le conseil en image le plus sophistiqué au monde. Nous pensons que le vrai style est plus qu'un simple vêtement—c'est un atout stratégique et une forme d'expression de soi puissante, rendue accessible à tous grâce à la fusion de l'expertise humaine et de la technologie IA avancée.",
    "aboutPage_paragraph2": "Aujourd'hui, notre plateforme sert de concierge de style personnel mondial, permettant aux individus de naviguer dans leur présence professionnelle et personnelle avec la confiance d'un maître tailleur, soutenue par la précision de l'IA générative.",
    "aboutPage_missionText": "Le style est le langage silencieux de l'identité. Notre mission est de vous donner les outils pour le parler couramment, avec une confiance absolue et un impact stratégique, partout dans le monde.",
    "aboutPage_techTitle": "L'Intelligence derrière l'Art",
    "aboutPage_techText_p1": "Nous utilisons les modèles multimodaux les plus AI et au-delà—pour effectuer une analyse visuelle en temps réel des vêtements, des textures et des silhouettes.",
    "aboutPage_techText_p2": "Chaque recommandation est fondée sur des principes de stylisme professionnel, la théorie des couleurs et les contextes historiques de la mode, garantissant que notre IA reste un outil d'élévation, et pas seulement d'automatisation.",
    "aboutPage_teamTitle": "Nos Visionnaires",
    "aboutPage_socialTitle": "Connectez-vous avec notre Avenir",
    "author_elara_vance_name": "Constantina",
    "author_elara_vance_bio": "Une vétérante des maisons de couture milanaises avec une profonde passion pour l'intersection entre la technologie et le stylisme traditionnel.",
    "elara-vance_role": "Directrice Artistique",
    "author_julian_sinclair_name": "Hannes",
    "author_julian_sinclair_bio": "Spécialisé dans l'éthique de l'IA et les modèles de traitement visuel, garantissant que notre stylisme reste humain et intuitif.",
    "julian-sinclair_role": "Chef de l'Architecture IA",
    "author_heidi_steiner_name": "Heidi Steiner",
    "author_heidi_steiner_bio": "Apporte des années d'expérience en conciergerie de boutique haut de gamme à la sphère numérique.",
    "heidi-steiner_role": "Concierge en Chef",
    "author_lukas_weber_name": "Lukas Weber",
    "author_lukas_weber_bio": "Se concentre sur les données de mode durable et la transparence de l'approvisionnement à l'ère numérique.",
    "lukas-weber_role": "Responsable Durabilité",
    "contact_title": "Connectons-nous",
    "contact_subtitle": "Vous avez des questions sur notre stylisme IA ou vous souhaitez réserver un atelier personnalisé ? Contactez-nous et nous vous répondrons sous 24 heures.",
    "contact_info_title": "Coordonnées de Contact",
    "contact_email_label": "E-mail",
    "contact_phone_label": "Téléphone",
    "contact_office_label": "Bureau",
    "contact_follow_us": "Suivez-nous",
    "contact_success_title": "Message Envoyé !",
    "contact_success_desc": "Merci de nous avoir contactés. Constantina examinera votre message et vous répondra sous peu.",
    "contact_form_name": "Nom",
    "contact_form_email": "E-mail",
    "contact_form_subject": "Sujet",
    "contact_form_message": "Message",
    "contact_form_submit": "Envoyer le Message",
    "contact_form_placeholder_name": "Votre nom",
    "contact_form_placeholder_email": "votre@email.com",
    "contact_form_placeholder_subject": "De quoi s'agit-il ?",
    "contact_form_placeholder_message": "Dites-nous comment nous pouvons vous aider...",
    "contact_form_send_another": "Envoyer un autre message",

    // Portfolio Page
    // Portfolio Page (Merged below)


    stylingAdvisorPage_greeting: "Bonjour! Je suis votre styliste personnel IA. Comment puis-je vous aider à améliorer votre style aujourd'hui?",
    stylingAdvisorPage_tagline: "Votre conseiller de mode personnel IA.",
    stylingAdvisorPage_chatSection: "Chat",
    stylingAdvisorPage_agentSelectorLabel: "Choisissez un Agent",
    stylingAdvisorPage_planSectionTitle: "Plan de Style",
    stylingAdvisorPage_planSectionDescription: "Générez une feuille de route de style personnalisée basée sur vos préférences.",
    stylingAdvisorPage_photoAnalysisSectionTitle: "Analyse Couleur",
    stylingAdvisorPage_photoAnalysisSectionDescription: "Téléchargez une photo pour découvrir votre palette de couleurs saisonnière.",
    stylingAdvisorPage_photoAnalysisButton: "Analyser ma Photo",
    stylingAdvisorPage_photoAnalysisSelectLabel: "Sélectionner parmi les Tenues Enregistrées",
    stylingAdvisorPage_agentsSectionTitle: "Agents Automatisés",
    stylingAdvisorPage_agentsDashboardTitle: "Mes Agents de Style Actifs",
    stylingAdvisorPage_createAgent: "Créer un Nouvel Agent",
    stylingAdvisorPage_noAgents: "Vous n'avez pas encore créé d'agents automatisés.",
    stylingAdvisorPage_thinking: "Réflexion...",
    stylingAdvisorPage_generatePlan: "Générer le Plan",
    stylingAdvisorPage_regeneratePlan: "Régénérer",
    stylingAdvisorPage_saveSuccess: "Enregistré!",
    stylingAdvisorPage_planSavedTitle: "Plan de Style {{duration}}",
    stylingAdvisorPage_placeholder: "Demandez conseil...",
    stylingAdvisorPage_planDuration_weekly: "Hebdomadaire",
    stylingAdvisorPage_planDuration_monthly: "Mensuel",
    stylingAdvisorPage_planDuration_quarterly: "Trimestriel",
    stylingAdvisorPage_mandatory_fields_tooltip: "Complétez votre Persona de Style dans le Profil pour déverrouiller.",
    stylingAdvisorPage_agent_styleQuestionnaire_name: "Questionnaire de Style",
    stylingAdvisorPage_agent_styleQuestionnaire_description: "Découvrez votre persona de style unique grâce aux questions-réponses.",
    stylingAdvisorPage_agent_business_name: "Professionnel Business",
    stylingAdvisorPage_agent_business_description: "Conseils pour les tenues d'entreprise et smart-casual.",
    stylingAdvisorPage_agent_vogueEditor_name: "Editorial Chic",
    stylingAdvisorPage_agent_vogueEditor_description: "Mode haute couture, audacieuse et tendance.",
    stylingAdvisorPage_agent_glamour_name: "Glamour Tapis Rouge",
    stylingAdvisorPage_agent_glamour_description: "Tenues de soirée et stylisme pour occasions spéciales.",
    stylingAdvisorPage_agent_locked_basic: "Plan Basique Requis",
    stylingAdvisorPage_agent_locked_premium: "Plan Premium Requis",
    stylingAdvisorPage_agent_locked_advanced: "Plan Avancé Requis",
    stylingAdvisorPage_planError: "Impossible de générer le plan de style. Veuillez réessayer.",
    stylingAdvisorPage_questionnaire_wizard_lifestyle_outdoor: "Combien de temps passez-vous à l'extérieur / dehors ?",
    "bookingForm_success_message_email": "Votre demande de réservation a été envoyée. Veuillez vérifier votre e-mail pour l'invitation au calendrier.",

    styleBot_questionnaire_intro: "Bonjour! Pour vous donner les meilleurs conseils, j'aimerais savoir : 1. Genre 2. Forme du corps 3. Forme du visage 4. Saison de couleur 5. Préférence de style. Vous pouvez répondre tout à la fois ou un par un!",
    styleBot_chip_female: "Femme",
    styleBot_chip_male: "Homme",
    styleBot_chip_non_binary: "Non-binaire",
    styleBot_chip_hourglass: "Corps en Sablier",
    styleBot_chip_pear: "Corps en Poire",
    styleBot_chip_rectangle: "Corps en Rectangle",
    styleBot_chip_athletic: "Carrure Athlétique",
    styleBot_chip_oval_face: "Visage Ovale",
    styleBot_chip_square_face: "Visage Carré",
    styleBot_chip_round_face: "Visage Rond",
    styleBot_chip_heart_face: "Visage en Cœur",
    styleBot_chip_winter: "Hiver",
    styleBot_chip_summer: "Été",
    styleBot_chip_autumn: "Automne",
    styleBot_chip_spring: "Printemps",
    styleBot_chip_minimalist: "Style Minimaliste",
    styleBot_chip_boho: "Boho Chic",
    styleBot_chip_classic: "Style Classique",
    styleBot_chip_streetwear: "Streetwear",

    styleAgent_modal_title: "Configurer l'Agent de Style",
    styleAgent_modal_desc: "Configurez un agent automatisé pour repérer les tendances et planifier des tenues pour vous en arrière-plan.",
    styleAgent_name_label: "Nom de l'Agent",
    styleAgent_name_placeholder: "ex., Scout Vacances d'Été",
    styleAgent_frequency_label: "Fréquence",
    styleAgent_season_label: "Saison Cible",
    styleAgent_focus_label: "Focus Style",
    styleAgent_create_btn: "Activer l'Agent",
    styleAgent_freq_weekly: "Hebdomadaire",
    styleAgent_freq_monthly: "Mensuel",

    "voucher_modal_title": "Acheter un Bon Cadeau",
    "voucher_modal_success_title": "Bon Créé !",
    "voucher_modal_success_message": "Votre bon a été créé avec succès. Vous pouvez copier le code ci-dessous.",
    "voucher_modal_service_label": "Sélectionner les Services",
    "voucher_modal_recipient_name_label": "Nom du Destinataire",
    "voucher_modal_recipient_name_placeholder": "ex. Marie Dupont",
    "voucher_modal_recipient_email_label": "Email du Destinataire",
    "voucher_modal_recipient_email_placeholder": "marie@exemple.com",
    "voucher_modal_message_label": "Message Personnel",
    "voucher_modal_message_placeholder": "Écrivez un petit mot...",
    "voucher_modal_purchase_button": "Acheter le Bon",
    "voucher_modal_purchasing": "Traitement...",
    "voucher_modal_copy_code": "Copier le Code",

    myStylesPage_title: 'Mes Styles',
    myStylesPage_empty_title: "Pas encore de styles",
    myStylesPage_empty_desc: "Créez des tenues dans la Cabine d'Essayage pour les voir ici.",
    myStylesPage_tab_outfits: "Tenues Enregistrées",
    myStylesPage_tab_items: "Articles de Garde-robe",
    myStylesPage_delete_confirm: "Êtes-vous sûr de vouloir supprimer ce style ?",
    myStylesPage_created_at: "Créé le",

    // Booking Page
    "bookingPage_title": "Réserver une Consultation",
    "bookingPage_tagline": "Planifiez une séance individuelle avec nos experts.",
    "bookingPage_service_personal": "Stylisme Personnel",
    "bookingPage_service_wardrobe": "Audit de Garde-robe",
    "bookingPage_service_shopping": "Personal Shopping",

    // Blog Page
    "blogPage_title": "Journal de Style",
    "blogPage_tagline": "Perspectives, tendances et conseils d'experts.",
    "blogPage_resources_title": "Ressources Exclusives",
    "blogPage_resources_locked_msg": "Passez à Premium pour accéder à nos guides de style.",
    "blogPage_resources_upgrade": "Mettre à Niveau",
    "blog_post_read_more": "Lire la Suite",
    "editorial_rss_title": "Actualités de l'Industrie",
    "editorial_rss_subtitle": "Flux curatés des meilleures publications de mode.",

    // Canvas / Dressing Room
    "canvas_seo_title": "Cabine d'Essayage Virtuelle - Constantina",
    "canvas_seo_desc": "Essayez des tenues virtuellement avec notre technologie IA. Votre styliste personnel.",
    "canvas_seo_keywords": "Essayage Virtuel IA, Styliste Personnel, Garde-robe Digitale, Fashion Tech, Créateur de Tenue",
    "canvas_uploadToStart": "Téléchargez une photo pour commencer",
    "canvas_view3D": "Voir en 3D",
    "canvas_shopTheLook": "Acheter le Look",
    "canvas_favorite_add": "Ajouter aux Favoris",
    "canvas_favorite_remove": "Retirer des Favoris",
    "sceneControl_title": "Contrôles de Scène",
    "sceneControl_background_label": "Arrière-plan",
    "sceneControl_custom_bg_placeholder": "Décrivez un arrière-plan...",
    "sceneControl_modelScale_label": "Échelle du Modèle",
    "sceneControl_bg_studio": "Studio",
    "sceneControl_bg_street": "Rue",
    "sceneControl_bg_nature": "Nature",
    "sceneControl_bg_cafe": "Café",
    "sceneControl_bg_beach": "Plage",
    "aboutPage_contactUs": "Contactez-nous",
    "legalPage_title": "Informations Légales",
    "legalPage_tagline": "Conditions d'utilisation, confidentialité et informations juridiques importantes.",
    "seo_legal_title": "Informations Légales - CGU & Confidentialité",
    "seo_legal_description": "Consultez nos conditions d'utilisation, politique de confidentialité, politique de cookies et mentions légales.",
    "seo_legal_kw1": "conditions d'utilisation",
    "seo_legal_kw2": "politique de confidentialité",
    "seo_legal_kw3": "informations légales",
    "seo_legal_kw4": "mentions légales",
    "legalPage_impressum_title": "Mentions Légales",
    "legalPage_impressum_content": "<p><b>Constantina Lifestyle AG</b><br/>Berne, Suisse<br/>Email: info@constantinalifestyle.one</p>",
    "legalPage_terms_title": "Conditions Générales d'Utilisation",
    "legalPage_terms_content": "<p>En utilisant notre service, vous acceptez nos conditions de traitement des actifs numériques et du contenu généré par l'IA.</p>",
    "legalPage_privacy_title": "Politique de Confidentialité",
    "legalPage_privacy_content": "<p>Nous accordons une grande importance à votre vie privée. Vos données biométriques et personnelles sont traitées localement dans la mesure du possible et sécurisées selon les normes de l'industrie.</p>",
    "legalPage_cookies_title": "Politique de Cookies",
    "legalPage_cookies_content": "<p>Nous utilisons des cookies essentiels pour maintenir votre session et vos préférences.</p>",
    "blogPage_resources_locked_title": "Débloquer le contenu Premium",
    "portfolioPage_title": "Styliste IA Premium & Personal Branding",
    "portfolioPage_tagline": "Élevez votre image professionnelle avec nos forfaits de stylisme sur mesure et nos solutions de personal branding.",
    "seo_services_title": "Services de Stylisme Premium",
    "seo_services_description": "Réservez des consultations de stylisme professionnelles, de curation de garde-robe et des sessions de personal branding.",
    "seo_services_kw1": "stylisme personnel",
    "seo_services_kw2": "curation de garde-robe",
    "seo_services_kw3": "conseil en image",
    "seo_services_kw4": "essai virtuel",
    "portfolioPage_campaigns_title": "Campagnes Actuelles",
    "portfolioPage_campaigns_tagline": "Offres exclusives pour une durée limitée.",
    "portfolioPage_membership_title": "Plans d'Adhésion",
    "portfolioPage_membership_tagline": "Débloquez des fonctionnalités et du contenu exclusifs.",
    "portfolioPage_services_title": "Nos Services",
    "portfolioPage_all_categories": "Toutes les Catégories",
    "portfolioPage_bookService": "Réserver un Service",
    "membership_cycle_weekly": "Hebdomadaire",
    "membership_cycle_monthly": "Mensuel",
    "membership_cycle_quarterly": "Trimestriel",
    "membership_subscribe_button": "S'abonner Maintenant",
    "membership_cycle_free": "Gratuit",
    "profilePage_membership_free": "Gratuit",
    "membership_feature_free_1": "Découverte de style standard",
    "membership_feature_free_2": "Flux de style trié sur le volet",
    "membership_feature_basic_1": "Accès Standard",
    "membership_feature_basic_2": "Garde-robe de Base",
    "membership_feature_basic_3": "Essais Limités",
    "membership_feature_basic_4": "Support Communautaire",
    "membership_feature_premium_1": "Accès Prioritaire",
    "membership_feature_premium_2": "Garde-robe Illimitée",
    "membership_feature_premium_3": "Essais Illimités",
    "membership_feature_premium_4": "Support E-mail",
    "membership_feature_premium_5": "Contenu Exclusif",
    "membership_feature_premium_style_tips": "Conseils Style IA",
    "membership_feature_advanced_1": "Toutes les Fonctions Premium",
    "membership_feature_advanced_2": "Consultation 1-sur-1",
    "membership_feature_advanced_3": "Accès Anticipé",
    "membership_feature_advanced_4": "Support VIP",
    "membership_feature_advanced_5": "Personal Shopper",
    "membership_feature_advanced_social_media": "Gen Contenu Social",
    "membership_feature_advanced_plan_integration": "Intégration Plan Style",
    "membership_feature_advanced_automated_shopping": "Achat Automatisé",
    "membership_feature_nextgen_1": "Insights Éco-Style",
    "membership_feature_nextgen_2": "Alertes Tendances Sociales",
    "membership_feature_nextgen_3": "Guides de Friperie Curatés",
    "membership_feature_nextgen_4": "Intégration Tendances TikTok",
    "portfolio_feature_1hr_video_call": "Appel Vidéo 1h",
    "portfolio_feature_style_questionnaire": "Questionnaire Style",
    "portfolio_feature_personalized_mood_board": "Mood Board Personnalisé",
    "portfolio_feature_all_online_features": "Toutes les Fonctions en Ligne",
    "portfolio_feature_virtual_try_on_session": "Session d'Essai Virtuel",
    "portfolio_feature_ai_lookbook": "Lookbook IA",
    "portfolio_feature_retail_search": "Recherche Retail",
    "portfolio_feature_all_ai_features": "Toutes les Fonctions IA",
    "portfolio_feature_in_person_consultation": "Consultation en Personne",
    "portfolio_feature_hands_on_styling": "Stylisme Pratique",
    "portfolio_feature_wardrobe_analysis": "Analyse de Garde-robe",
    "portfolio_feature_declutter_guide": "Guide de Désencombrement",
    "portfolio_feature_shopping_list": "Liste de Courses",
    "portfolio_feature_ai_outfit_pairing": "Combinaison Tenue IA",
    "portfolio_feature_seasonal_capsule": "Capsule Saisonnière",
    "portfolio_feature_event_consultation": "Consultation Événement",
    "portfolio_feature_3_outfit_proposals": "3 Propositions de Tenues",
    "portfolio_feature_accessorizing_guide": "Guide d'Accessoirisation",
    "portfolio_feature_event_virtual_try_on": "Essai Virtuel Événement",
    "portfolio_feature_pose_variation_check": "Vérification de Variations",
    "portfolio_feature_shopping_consultation": "Conseil Shopping",
    "portfolio_feature_curated_shopping_list": "Liste Shopping Curatée",
    "portfolio_feature_style_integration_session": "Session d'Intégration Style",
    "portfolio_feature_ai_product_search": "Recherche Produit IA",
    "portfolio_feature_vto_shortlist": "Sélection VTO",
    "portfolio_feature_makeup_video_call": "Appel Vidéo Maquillage",
    "portfolio_feature_product_recommendations": "Recommandations Produits",
    "portfolio_feature_technique_guide": "Guide de Technique",
    "portfolio_feature_ai_face_analysis": "Analyse de Visage IA",
    "portfolio_feature_virtual_makeup_try_on": "Essai Maquillage Virtuel",
    "portfolio_feature_color_consultation": "Consultation Couleur",
    "portfolio_feature_digital_palette": "Palette Numérique",
    "portfolio_feature_outfit_color_guide": "Guide Couleur Tenues",
    "portfolio_feature_ai_color_detection": "Détection Couleur IA",
    "portfolio_feature_interactive_palette": "Palette Interactive",
    "portfolio_feature_team_style_guide": "Guide Style Équipe",
    "portfolio_feature_brand_identity_alignment": "Alignement Identité Marque",
    "portfolio_feature_group_qa": "F&A de Groupe",
    "portfolio_feature_executive_presence": "Présence Exécutive",
    "portfolio_feature_personal_shopping_day": "Journée Personal Shopping",
    "portfolio_feature_keynote_speech": "Discours de Keynote",
    "portfolio_feature_pop_up_styling": "Bar à Stylisme Pop-up",
    "portfolio_feature_wardrobe_edit": "Tri de Garde-robe",
    "portfolio_feature_style_guide": "Guide de Style",
    "portfolio_feature_personal_shopping": "Shopping Personnalisé",
    "portfolio_feature_makeup_lesson": "Leçon de Maquillage",
    "portfolio_feature_follow_up": "Séance de Suivi",
    "portfolio_feature_photoshoot": "Séance Photo Pro",
    "portfolio_feature_hair_consultation": "Consultation Coiffure",
    "portfolio_feature_vip_concierge": "Conciergerie VIP",

    "nav_user_status_current": "Actuel",
    "nav_user_status_active": "Session active",
    "nav_user_action_login": "Connexion",
    "nav_user_action_delete": "Supprimer l'utilisateur",
    "nav_admin_model_config": "Admin : Configuration du modèle",
    "nav_admin_gen_model": "Modèle de génération d'image",
    "nav_admin_gen_model_desc": "Sélectionnez le modèle Gemini pour la génération.",
    "nav_admin_model_flash": "Gemini 1.5 Flash (Par défaut)",
    "nav_admin_model_pro": "Gemini 1.5 Pro (Haute qualité)",
    "nav_membership_recommended": "RECOMMANDÉ",
    "membership_most_popular": "Plus populaire",
    "nav_app_download_prefix_ios": "Télécharger dans l'",
    "nav_app_store_ios": "App Store",
    "nav_app_download_prefix_android": "DISPONIBLE SUR",
    "nav_app_store_android": "Google Play",

    "home_hero_title": "Maîtrisez votre style personnel avec la précision de l'IA",
    "home_hero_title_new": "Élevez votre présence. Ne vous demandez plus jamais quoi porter.",
    "home_hero_subtitle": "Votre concierge de mode IA professionnel. Découvrez des looks personnalisés adaptés à votre palette unique, votre silhouette et votre image de marque personnelle.",
    "home_hero_cta": "Commencer la session de coiffeur",
    "home_how_it_works_title": "Votre parcours vers l'excellence suisse et le style italien",
    "home_how_it_works_step1_title": "1. Analyse visuelle de précision",
    "home_how_it_works_step1_desc": "Commencez par une analyse visuelle qui capture votre aura unique. Notre IA de conception suisse cartographie vos proportions avec une précision chirurgicale.",
    "home_how_it_works_step2_title": "2. Regards italiens curatés",
    "home_how_it_works_step2_desc": "Explorez des recommandations curatées avec un œil italien pour le détail, garantissant que chaque combinaison dégage 'Sprezzatura' et confiance.",
    "home_how_it_works_step3_title": "3. Curation d'expert & Maîtrise",
    "home_how_it_works_step3_desc": "La touche finale de la maîtrise humaine. Réservez une séance avec nos stylistes experts pour finaliser votre transformation avec un soin personnel.",
    "home_seo_title": "Constantina | Essai virtuel IA & Styliste personnelle",
    "home_seo_desc": "Transformez votre expérience shopping avec notre cabine d'essayage virtuelle IA. Découvrez votre identité de style avec les tendances 2026 comme Transformative Teal et Quiet Luxury.",
    "home_seo_keywords": "Essayage Virtuel IA, Styliste Personnel, Garde-robe Digitale, Fashion Tech, Créateur de Tenue, Transformative Teal, Y2K Renaissance, Mode Durable, Stealth Wealth, Tendances Mode 2026",
    "home_empathy_title": "Le style est personnel. Nous le comprenons.",
    "home_empathy_desc": "Nous croyons que la mode doit renforcer, pas intimider. Notre IA apprend vos préférences uniques, votre morphologie et votre mode de vie pour vous offrir des recommandations qui vous ressemblent vraiment — pas un algorithme suiveur de tendances.",
    "home_press_title": "Vu dans",
    "profilePage_measurements_colorSeason_label": "Profil de couleur (Saison)",
    "profilePage_measurements_ai_auto_detect": "Auto-détection IA",
    "profilePage_stylePersona_analyzing_dna": "Analyse de votre ADN de style...",

    "profile_seo_title": "Mon Profil - Constantina",
    "profile_seo_desc": "Gérez votre persona de style, votre abonnement et vos paramètres de compte sur Constantina.",
    "profile_seo_keywords": "profil utilisateur, persona de style, paramètres de compte, Constantina",

    "canvas_result_alt": "Résultat de l'essai virtuel",
    "pressPage_title": "Presse & Collaborations",
    "pressPage_tagline": "À la pointe de la conversation sur l'innovation de la mode numérique.",
    "pressPage_featured_title": "Vu dans",
    "pressPage_partners_title": "Marques Partenaires",
    "press_vogue_quote": "Redéfinit le stylisme personnel avec la précision de l'IA.",
    "press_harpers_quote": "L'avenir de la garde-robe numérique est ici.",
    "press_elle_quote": "Un mélange harmonieux de technologie et de haute couture.",
    "press_brand1_desc": "Intégration exclusive de showroom numérique.",
    "press_brand2_desc": "Partenariat d'essai virtuel.",
    "press_brand3_desc": "Collection capsule curatée.",
    "rss_source_vogue": "Vogue",
    "rss_source_elle": "Elle",
    "rss_source_harpers": "Harper's Bazaar",
    "rss_source_fashionista": "Fashionista",
    "rss_source_bof": "Business of Fashion",
    "rss_source_journelles": "Journelles",
    "rss_source_highsnobiety": "Highsnobiety",
    "rss_source_instyle": "InStyle",
    "rss_source_glamour": "Glamour",
    "rss_source_beige": "Beige",
    "rss_source_refinery29": "Refinery29",
    "rss_source_grazia": "Grazia",
    "rss_source_originalcopy": "The Original Copy",
    "rss_source_modepilot": "Modepilot",
    "rss_source_fashionunited": "FashionUnited",
    "rss_source_jolie": "Jolie",
    "rss_source_cosmopolitan": "Cosmopolitan",
    "rss_source_mashasedgwick": "Masha Sedgwick",
    "rss_source_ohhcouture": "Ohh Couture",
    "rss_source_carodaur": "Caro Daur",
    "rss_source_novalanalove": "Novalanalove",
    "payment_modal_select_method": "Sélectionner le mode de paiement",
    "payment_method_card": "Carte de Crédit / Débit",
    "payment_method_paypal": "PayPal",
    "payment_method_twint": "TWINT (Suisse)",
    "payment_method_sofort": "Sofort / Klarna (Allemagne)",
    "payment_continue_to": "Continuer vers {{method}}",
    "nav_logout": "Se déconnecter",
    "generation_alpha": "Gén Alpha",
    "generation_z": "Gén Z",
    "generation_millennial": "Millennials",
    "generation_classic": "Classique / Boomers",
    "trend_alpha_digital_twin_title": "Synchronisation Digital Twin",
    "trend_alpha_gaming_couture_title": "Couture Méta-Gaming",
    "trend_z_y2k_redux_title": "Esthétique Y2K Redux",
    "trend_z_thrifting_elite_title": "Curations de Friperie Profonde",
    "trend_millennial_80s_glam_title": "Glamour Power 80s",
    "trend_millennial_quiet_luxury_title": "Luxe Discret",
    "trend_classic_heritage_title": "Héritage de Plein Air",
    "trend_tag_ai_native": "Natif IA",
    "trend_tag_metaverse": "Métavers",
    "trend_tag_nostalgia": "Nostalgie",
    "trend_tag_eco_conscious": "Éco-Élite",
    "trend_tag_sophisticated": "Sophistiqué",
    "trend_tag_timeless": "Intemporel",
    "portfolio.alpha.title": "Identités Numériques Gén Alpha",
    "portfolio.alpha.desc": "Relier les skins virtuels aux garde-robes de luxe physiques pour la première génération native du numérique.",
    "portfolio.z.title": "Individualité Gén Z",
    "portfolio.z.desc": "Friperie propulsée par l'IA et repérage des tendances sociales pour les précurseurs.",
    "portfolio.millennial.title": "Pic de Carrière Millénial",
    "portfolio.millennial.desc": "Glamour des années 80 élevé et luxe discret intemporel pour le professionnel moderne.",
    "trends_seo_title": "Tendances Mode 2026 | Constantina",
    "trends_seo_desc": "Explorez les dernières tendances mode Gen Z et mondiales. Gardez une longueur d'avance grâce aux insights propulsés par l'IA.",
    "trends_seo_keywords": "tendances mode, style gen z, mode 2026, repérage de tendances, mode durable",

    // Wardrobe & Outfit Stack (New)
    "wardrobe_category_Tops": "Hauts",
    "wardrobe_category_Jackets": "Vestes & Manteaux",
    "wardrobe_category_Outerwear": "Vêtements d'extérieur",
    "wardrobe_category_Dresses": "Robes",
    "wardrobe_category_Bottoms": "Bas",
    "wardrobe_category_Shoes": "Chaussures",
    "wardrobe_category_Bags": "Sacs",
    "wardrobe_category_Eyewear": "Lunettes",
    "wardrobe_category_Jewelry": "Bijoux",
    "wardrobe_category_Other": "Accessoires & Autre",
    "wardrobe_category_All": "Toutes les catégories",

    "lifeSphere_selection_title": "Votre focus actuel",
    "lifeSphere_selection_desc": "Sélectionnez votre Life Sphere active pour personnaliser les recommandations.",
    "lifeSphere_executive_title": "Ascension Exécutive",
    "lifeSphere_executive_desc": "Présence professionnelle élevée et power dressing.",
    "lifeSphere_romantic_title": "Renaissance Romantique",
    "lifeSphere_romantic_desc": "Stylisme séduisant et confiant pour votre vie amoureuse.",
    "lifeSphere_matriarch_title": "Matriarche sans effort",
    "lifeSphere_matriarch_desc": "Élégance chic et fonctionnelle pour la vie de famille.",
    "lifeSphere_creative_title": "Épanouissement Créatif",
    "lifeSphere_creative_desc": "Des silhouettes audacieuses qui reflètent la croissance artistique.",
    "wardrobe_tab_garments": "Vêtements",
    "wardrobe_tab_accessories": "Accessoires",
    "wardrobe_tab_sets": "Ensembles Curatés",
    "wardrobe_upload_garment_title": "Ajouter un vêtement",
    "wardrobe_upload_accessory_title": "Ajouter un accessoire",
    "wardrobe_upload_garment": "Télécharger",
    "wardrobe_upload_accessory": "Télécharger",

    "outfitStack_title": "Composition de Tenue",
    "outfitStack_undo": "Annuler",
    "outfitStack_redo": "Rétablir",
    "outfitStack_empty_prompt": "Sélectionnez des articles de votre garde-robe pour commencer.",
    "outfitStack_changeColor_aria": "Changer la couleur de {{itemName}}",
    "outfitStack_adjust_aria": "Ajuster {{itemName}}",
    "outfitStack_remove_aria": "Retirer {{itemName}}",
    "outfitStack_findSimilar_aria": "Trouver des articles similaires à {{itemName}}",
    "outfitStack_findSimilar_main": "Acheter Similaire",
    "outfitStack_addToLookbook": "Ajouter au Lookbook",
    "outfitStack_suggestVariations": "Suggérer des Variations",
    "outfitStack_analyzeColor": "Analyser la Palette",
    "outfitStack_creativeTools": "Outils Créatifs",
    "outfitStack_saveOutfitFirstForLookbook": "Sauvegardez d'abord la tenue pour l'ajouter au lookbook",
    "alert_selectGarmentFirst": "Veuillez d'abord sélectionner un vêtement principal.",

    // Client Stories
    "testimonialsPage_title": "Histoires de Clients",
    "testimonialsPage_tagline": "Découvrez les témoignages de notre communauté mondiale de passionnés de style.",
    "testimonialsPage_workInAction_title": "Travail en Action",
    "testimonialsPage_workInAction_tagline": "Résultats réels de nos sessions de stylisme et outils.",
    "testimonialsPage_workInAction_connectButton": "Connecter les Comptes",
    "testimonialsPage_workInAction_connecting": "Connexion...",
    "testimonialsPage_workInAction_youtubeTitle": "Métamorphoses YouTube",
    "testimonialsPage_workInAction_instagramTitle": "Reels Instagram",
    "testimonialsPage_workInAction_twitterTitle": "Tweets Mode",
    "threeSixty_dragToRotate": "Glisser pour tourner",

    // Testimonials
    "testimonial_name_1": "Sophie M.",
    "testimonial_location_paris": "Paris, France",
    "testimonial_quote_1": "Constantina a transformé ma garde-robe. Je sais enfin quelles couleurs me font briller !",
    "testimonial_name_2": "Alessandro R.",
    "testimonial_location_milan": "Milan, Italie",
    "testimonial_quote_2": "La séance de stylisme en personne a changé la donne pour mon image professionnelle.",
    "testimonial_name_3": "Emma W.",
    "testimonial_location_london": "Londres, Royaume-Uni",
    "testimonial_quote_3": "Trier mon placard avec les outils IA a rendu le désencombrement amusant et efficace.",
    "testimonial_name_4": "Wei L.",
    "testimonial_location_shanghai": "Shanghai, Chine",
    "testimonial_quote_4": "J'ai utilisé le service de stylisme événementiel pour un gala. Les recommandations étaient parfaites.",
    "testimonial_name_5": "Kenji T.",
    "testimonial_location_tokyo": "Tokyo, Japon",
    "testimonial_quote_5": "La fonction Style Persona a capturé mon esthétique mieux que je ne pouvais la décrire.",
    "testimonial_name_6": "Claire D.",
    "testimonial_location_montreal": "Montréal, Canada",
    "testimonial_quote_6": "L'essayage virtuel m'a fait gagner tellement de temps. Je recommande vivement !",
    "testimonial_name_7": "Elena G.",
    "testimonial_location_barcelona": "Barcelone, Espagne",
    "testimonial_quote_7": "J'adore les plans de style hebdomadaires. Cela enlève le stress de s'habiller pour le travail.",
    "testimonial_name_8": "Omar K.",
    "testimonial_location_dubai": "Dubaï, EAU",
    "testimonial_quote_8": "Trouver des articles similaires à partir de photos est magique. J'ai trouvé une veste que je cherchais depuis des mois.",

    // Social Content
    "reel_1_caption": "Ambiance estivale avec notre nouvelle collection en lin ! ☀️ #summerstyle",
    "reel_2_caption": "Prête pour la saison des galas. ✨ #eveningwear #glamour",
    "reel_3_caption": "Inspiration street style de Tokyo. 🇯🇵 #streetwear",
    "youtube_1_title": "10 Essentiels de Garde-robe",
    "youtube_1_published": "il y a 2 jours",
    "youtube_2_title": "Comment porter le blazer oversize",
    "youtube_2_published": "il y a 1 semaine",
    "tweet_1_author": "Fashion Weekly",
    "tweet_1_text": "Le retour de l'esthétique 90s est là pour durer. Quelle est votre pièce rétro préférée ? 🧥",
    "tweet_1_timestamp": "il y a 2h",
    "tweet_2_author": "Style Scout",
    "tweet_2_text": "Je viens de voir la nouvelle collection Constantina. C'est le feu ! 🔥",
    "tweet_2_timestamp": "il y a 5h",

    // Lookbook & Social
    "lookbookCreatorModal_aspectRatio": "Rapport d'Aspect",
    "lookbookCreatorModal_socialLayout": "Mise en page Sociale (style Influenceur)",
    "lookbookCreatorModal_socialLayoutDesc": "Optimisé pour Instagram Stories et TikTok.",
    "lookbookCreatorModal_socialCaption": "Légende Sociale IA",
    "lookbookCreatorModal_captionPlaceholder": "La légende générée par l'IA apparaîtra ici...",
    "lookbookCreatorModal_download": "Télécharger l'Image",
    "lookbookCreatorModal_error_enterName": "Veuillez entrer un nom pour votre lookbook.",

    // Profile Page
    "profilePage_measurements_title": "Mesures & Attributs",
    "profilePage_measurements_description": "Tenez vos détails à jour pour de meilleures recommandations de taille.",
    "profilePage_personalDetails_title": "Détails Personnels",
    "profilePage_measurements_height": "Taille",
    "profilePage_measurements_weight": "Poids",
    "profilePage_measurements_chest": "Tour de poitrine",
    "profilePage_measurements_waist": "Tour de taille",
    "profilePage_measurements_hips": "Tour de hanches",
    "profilePage_measurements_height_placeholder": "cm/ft",
    "profilePage_measurements_weight_placeholder": "kg/lbs",
    "profilePage_measurements_chest_placeholder": "cm/in",
    "profilePage_measurements_waist_placeholder": "cm/in",
    "profilePage_measurements_hips_placeholder": "cm/in",
    "profilePage_measurements_shoeSize": "Pointure",
    "profilePage_measurements_shoeSize_placeholder": "ex. 42 / 9",
    "profilePage_attributes_detected_title": "Attributs Détectés",
    "profilePage_attributes_bodySize": "Taille Corporelle",
    "profilePage_attributes_hairColor": "Couleur de Cheveux",
    "profilePage_attributes_eyeColor": "Couleur des Yeux",
    "profilePage_attributes_faceShape": "Forme du Visage",
    "profilePage_attributes_notDetected": "Non détecté",
    "profilePage_preferredRetailers_label": "Détaillants Préférés",
    "profilePage_preferredRetailers_description": "Sélectionnez les marques que vous aimez pour de meilleures recommandations.",
    "profilePage_membership_title": "Adhésion",
    "profilePage_membership_tagline": "Gérez votre abonnement.",
    "profilePage_membership_level": "Plan Actuel",
    "profilePage_membership_expiry_date": "Date d'Expiration",
    "profilePage_membership_status_basic": "Basique",
    "profilePage_membership_status_active": "{{level}} - Actif jusqu'au {{date}}",
    "profilePage_membership_status_active_no_date": "{{level}} - Actif",
    "profilePage_membership_status_expired": "{{level}} - Expiré le {{date}}",
    "profilePage_membership_basic": "Basique",
    "profilePage_membership_premium": "Premium",
    "profilePage_membership_advanced": "Avancé",
    "profilePage_membership_nextgen": "Accès NextGen",
    "profilePage_membership_current": "Plan Actuel",
    "profilePage_membership_change_hint": "Modifiable uniquement via paiement de mise à niveau",
    "profilePage_membership_upgrade": "Mettre à Niveau",
    "profilePage_membership_label": "Adhésion",
    "profilePage_membership_month": "mois",
    "profilePage_membership_current_label": "Plan Actuel",
    "profilePage_membership_upgrade_button": "Mettre à Niveau",
    "profilePage_mobileApp_title": "Emmenez votre style partout",
    "profilePage_mobileApp_description": "En tant que membre premium, vous avez un accès exclusif à notre application mobile. Gérez votre garde-robe, recevez des briefings quotidiens et utilisez la Style Sandbox en déplacement.",
    "profilePage_mobileApp_qrTitle": "Scanner pour télécharger",
    "travelPage_seo_title": "Liste de bagages pour voyage de luxe & Resort Wear",
    "travelPage_seo_desc": "Créez la liste de bagages de luxe ultime. Des tenues de vacances aux essentiels pour un city break, planifiez votre escapade avec des recommandations personnalisées par IA.",
    "travelPage_seo_keywords": "liste de bagages de luxe, mode voyage, tenues de vacances, garde-robe chic, essentiels voyage, styliste IA",
    "travelPage_diaries_title": "Carnets de Voyage",
    "travelPage_no_lookbooks": "Aucun lookbook de voyage trouvé.",
    "travelPage_destination_label": "Où allez-vous ?",
    "travelPage_destination_placeholder": "ex. Paris, Tulum, Aspen",
    "travelPage_style_summer": "Été / Plage",
    "travelPage_style_winter": "Hiver / Ski",
    "travelPage_generating": "Préparation de la garde-robe...",
    "travelPage_generate_btn": "Générer la liste de bagages",
    "travelPage_result_title": "Votre garde-robe pour {{destination}}",
    "travelPage_save_diary": "Enregistrer dans le carnet",
    "travelPage_export_pdf": "Exporter en PDF",
    "capsuleGenerator_empty_state": "Sélectionnez vos préférences et cliquez sur \"Générer\" pour voir votre capsule personnelle.",
    "auth_coupon_placeholder": "Code promo (facultatif)",
    "user_status_registered": "Inscrit",
    "user_status_validated": "En attente d'approbation",
    "user_status_active": "Actif",
    "user_status_inactive": "Inactif",
    "user_status_deleted": "Supprimé",
    "auth_pending_admin": "Compte en attente d'approbation par l'administrateur",
    "auth_pending_confirmation": "Veuillez confirmer votre adresse e-mail.",
    "auth_account_deactivated": "Ce compte a été désactivé.",

    // Style Discovery Wizard
    "stylingAdvisorPage_questionnaire_wizard_title": "Assistant de Découverte de Style",
    "stylingAdvisorPage_questionnaire_wizard_success": "Votre persona de style a été découverte !",
    "stylingAdvisorPage_questionnaire_wizard_step_evolution": "Quelle phase de développement intérieur reflétez-vous actuellement ?",
    "stylingAdvisorPage_questionnaire_wizard_phase_emergence": "Émergence",
    "stylingAdvisorPage_questionnaire_wizard_phase_leadership": "Leadership",
    "stylingAdvisorPage_questionnaire_wizard_phase_reclamation": "Réclamation",
    "stylingAdvisorPage_questionnaire_wizard_phase_transition": "Transition",
    "stylingAdvisorPage_questionnaire_wizard_phase_mastery": "Maîtrise",
    "stylingAdvisorPage_questionnaire_wizard_step_archetype": "Quel est votre archétype de style actuel ?",
    "stylingAdvisorPage_questionnaire_wizard_arch_muse": "Muse",
    "stylingAdvisorPage_questionnaire_wizard_arch_warrior": "Guerrier",
    "stylingAdvisorPage_questionnaire_wizard_arch_creator": "Créateur",
    "stylingAdvisorPage_questionnaire_wizard_arch_healer": "Guérisseur",
    "stylingAdvisorPage_questionnaire_wizard_arch_ruler": "Dirigeant",
    "stylingAdvisorPage_questionnaire_wizard_arch_magician": "Magicien",
    "stylingAdvisorPage_questionnaire_wizard_step_generation": "À quelle génération appartenez-vous ?",
    "stylingAdvisorPage_questionnaire_wizard_gen_alpha": "Gén Alpha",
    "stylingAdvisorPage_questionnaire_wizard_gen_z": "Gén Z",
    "stylingAdvisorPage_questionnaire_wizard_gen_millennial": "Millénaire",
    "stylingAdvisorPage_questionnaire_wizard_gen_x": "Gén X",
    "stylingAdvisorPage_questionnaire_wizard_gen_boomer": "Boomer",
    "stylingAdvisorPage_questionnaire_wizard_gen_classic": "Classique",
    "stylingAdvisorPage_questionnaire_wizard_step_lifestyle": "Parlez-nous de votre mode de vie",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_office": "Combien de temps passez-vous au bureau ?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_travel": "Combien voyagez-vous ?",
    "stylingAdvisorPage_questionnaire_wizard_intensity_none": "Aucune",
    "stylingAdvisorPage_questionnaire_wizard_intensity_low": "Basse",
    "stylingAdvisorPage_questionnaire_wizard_intensity_medium": "Moyenne",
    "stylingAdvisorPage_questionnaire_wizard_intensity_high": "Haute",
    "stylingAdvisorPage_questionnaire_wizard_step_persona": "Sélectionnez votre persona de style",
    "stylingAdvisorPage_questionnaire_wizard_finish": "Découvrir mon style",
    "homePage_solveStyleProblem_link": "Résoudre un problème de style",
    "homePage_bookSession_link": "Réserver une séance",
    "homePage_forCompanies_link": "Pour les entreprises",
    "stylingAdvisorPage_questionnaire_wizard_persona_minimalist": "Minimaliste",
    "stylingAdvisorPage_questionnaire_wizard_persona_bohoChic": "Boho Chic",
    "stylingAdvisorPage_questionnaire_wizard_persona_classicProfessional": "Classique Professionnel",
    "stylingAdvisorPage_questionnaire_wizard_persona_streetwear": "Streetwear",
    "stylingAdvisorPage_questionnaire_wizard_persona_avantGarde": "Avant-Garde",
    "stylingAdvisorPage_questionnaire_wizard_persona_vintageRetro": "Vintage Rétro",
    "stylingAdvisorPage_questionnaire_wizard_persona_activewear": "Vêtements de Sport",
    "stylingAdvisorPage_questionnaire_wizard_persona_glamorous": "Glamour"
  }
};
